import { create } from 'zustand'

export type ActiveGuidState = {
  submissionId: string | undefined
}
export type ActiveGuidStore = ActiveGuidState & {
  setSubmissionId: (submissionId: string) => void
  clearStorage: () => void
  reset: () => void
}

export const useSubmissionId = create<ActiveGuidStore>((set) => {
  return {
    submissionId: localStorage?.getItem('submissionId') || undefined,
    setSubmissionId: (submissionId) => {
      localStorage?.setItem('submissionId', submissionId)
      set({ submissionId })
    },
    clearStorage: () => localStorage?.removeItem('submissionId'),
    reset: () => {
      localStorage?.removeItem('submissionId')
      set({ submissionId: undefined })
    },
  }
})
